export const getZodiacSigns = () => {
    const zodiacIcons = [
        {aries: '\\ue00C'},
        {taurus: '\\ue015'},
        {gemini: '\\ue00F'},
        {cancer: '\\ue00D'},
        {leo: '\\ue010'},
        {virgo: '\\ue016'},
        {libra: '\\ue011'},
        {scorpio: '\\ue014'},
        {sagittarius: '\\ue013'},
        {capricorn: '\\ue00E'},
        {aquarius: '\\ue00B'},
        {pisces: '\\ue012'}
    ]
    return zodiacIcons
}

export const getKsBaseIcons = () => {
    const baseIcons = [
        {value: '\\ue000', label: 'texas', code: 'E000'},
        {value: '\\ue001', label: 'cross', code: 'E001'},
        {value: '\\ue002', label: 'rainbow', code: 'E002'},
        {value: '\\ue003', label: 'double heart', code: 'E003'},
        {value: '\\ue004', label: 'star', code: 'E004'},
        {value: '\\ue005', label: 'heart', code: 'E005'},
        {value: '\\ue00A', label: 'cactus', code: 'E00A'},
        {value: '\\ue008', label: 'sun', code: 'E008'},
        {value: '\\ue009', label: 'ks logo', code: 'E009'},
        {value: '\\ue007', label: 'moon', code: 'E007'},
        {value: '\\ue006', label: 'xo quad', code: 'E006'},
        // Please do not remove the following lines. Always keep them hidden and display them dynamically.
        {value: '\\ue017', label: 'love', code: 'E017', hidden: true},
        {value: '\\ue018', label: 'xo', code: 'E018', hidden: true}
    ]
    return baseIcons
}

export const getAllIcons = () => {
    const zodiacIcons = [
        {aries: '\\ue00C'},
        {taurus: '\\ue015'},
        {gemini: '\\ue00F'},
        {cancer: '\\ue00D'},
        {leo: '\\ue010'},
        {virgo: '\\ue016'},
        {libra: '\\ue011'},
        {scorpio: '\\ue014'},
        {sagittarius: '\\ue013'},
        {capricorn: '\\ue00E'},
        {aquarius: '\\ue00B'},
        {pisces: '\\ue012'}
    ]

    const baseIcons = [
        {texas: '\\ue000'},
        {cross: '\\ue001'},
        {rainbow: '\\ue002'},
        {'double heart': '\\ue003'},
        {star: '\\ue004'},
        {heart: '\\ue005'},
        {cactus: '\\ue00A'},
        {sun: '\\ue008'},
        {'ks logo': '\\ue009'},
        {moon: '\\ue007'},
        {'xo quad': '\\ue006'},
        {love: '\\ue017'},
        {xo: '\\ue018'}
    ]

    return [...zodiacIcons, ...baseIcons]
}

export const replaceSymbols = (str) => {
    try {
        const map = Object.fromEntries(
            getAllIcons().map((o) => [
                String.fromCharCode(parseInt(Object.values(o)[0].slice(2), 16)),
                Object.keys(o)[0]
            ])
        )
        return [...str].map((c) => (map[c] ? `{{${map[c]}}}` : c)).join('')
    } catch (e) {
        console.log(e.message)
        return ''
    }
}

export const makeEngravingGtmObject = (selectedFont, engravingLines) => {
    let mainEngravingData, productEngravingData
    try {
        const face_1 = engravingLines?.face_1
        const face_2 = engravingLines?.face_2
        const face1Line =
            selectedFont?.face_1 === 'Monogram'
                ? face_1?.monogram
                : `${face_1?.line1}${face_1?.line2}${face_1?.line3}${face_1?.line3}${face_1?.line4}${face_1?.line5}`
        const face2Line =
            selectedFont?.face_2 === 'Monogram'
                ? face_2?.monogram
                : `${face_2?.line1}${face_2?.line2}${face_2?.line3}${face_2?.line3}${face_2?.line4}${face_2?.line5}`
        const gtmEngravedLine1 = replaceSymbols(
            face1Line
                ?.replaceAll('{{#font=kendra-characters-24-01-22.ttf}}', '')
                ?.replaceAll('{{/}}', '')
        )
        const gtmEngravedLine2 = replaceSymbols(
            face2Line
                ?.replaceAll('{{#font=kendra-characters-24-01-22.ttf}}', '')
                ?.replaceAll('{{/}}', '')
        )
        const gtmEngravedFullLine = replaceSymbols(
            (face1Line + face2Line)
                ?.replaceAll('{{#font=kendra-characters-24-01-22.ttf}}', '')
                ?.replaceAll('{{/}}', '')
        )
        const z = getZodiacSigns().map((o) => Object.keys(o)[0])
        const b = getKsBaseIcons().map((o) => o.label)
        const s = (gtmEngravedFullLine?.match(/{{(.*?)}}/g) || [])?.map((x) => x.slice(2, -2))
        const zodiacStr = [...new Set(s.filter((x) => z.includes(x)))]
            ?.map((x) => `{{${x}}}`)
            .join('')
        const baseStr = [...new Set(s.filter((x) => b.includes(x)))]
            ?.map((x) => `{{${x}}}`)
            .join('')
        mainEngravingData = {
            addEngraving: 'yes',
            engravingText: gtmEngravedFullLine,
            engravingZodiacsign: zodiacStr,
            engravingSymbol: baseStr
        }
        productEngravingData = {
            engravable: 'true',
            dimension75: selectedFont.face_1, // "Claredon" or "Vanessa"(Font)
            dimension76: gtmEngravedLine1, // Front Engraving Text
            dimension77: gtmEngravedLine2 ? 'true' : 'false', // True (Engraving Back)
            dimension78: gtmEngravedLine2 ? gtmEngravedLine2 : null, // Back Engraving Text
            dimension79: gtmEngravedLine1 ? selectedFont.face_1 : null, // "Claredon" or "Vanessa" (Front Engraving Font)
            dimension80: gtmEngravedLine2 ? selectedFont.face_2 : null // "Claredon" or "Vanessa"   (Back Engraving Font)
        }
    } catch (e) {
        console.log(e.message)
    }

    return {
        mainEngravingData: mainEngravingData,
        productEngravingData: productEngravingData
    }
}

export const isRedtrictedWordActive = (engravingLines, restrictionListArray, selectedFont) => {
    return (
        // Face 1
        (selectedFont?.face_1 === 'Monogram' &&
            restrictionListArray?.indexOf(engravingLines?.['face_1']?.monogram) !== -1) ||
        restrictionListArray?.indexOf(engravingLines?.['face_1']?.line1) !== -1 ||
        restrictionListArray?.indexOf(engravingLines?.['face_1']?.line2) !== -1 ||
        restrictionListArray?.indexOf(engravingLines?.['face_1']?.line3) !== -1 ||
        restrictionListArray?.indexOf(engravingLines?.['face_1']?.line4) !== -1 ||
        restrictionListArray?.indexOf(engravingLines?.['face_1']?.line5) !== -1 ||
        // Face 2
        (selectedFont?.face_2 === 'Monogram' &&
            restrictionListArray?.indexOf(engravingLines?.['face_2']?.monogram) !== -1) ||
        restrictionListArray?.indexOf(engravingLines?.['face_2']?.line1) !== -1 ||
        restrictionListArray?.indexOf(engravingLines?.['face_2']?.line2) !== -1 ||
        restrictionListArray?.indexOf(engravingLines?.['face_2']?.line3) !== -1 ||
        restrictionListArray?.indexOf(engravingLines?.['face_2']?.line4) !== -1 ||
        restrictionListArray?.indexOf(engravingLines?.['face_2']?.line5) !== -1
    )
}

export const formatMonogramInput = (value) => {
    if (!value) return value
    return value.replace(/[^a-z]/gi, '') // keeps A–Z and a–z only
}
